// @flow

import React from 'react';
import styles from './inputField.scss';

import { convertToRegex } from '../../../../services/helpers';

type Props = {
  id?: string,
  name?: string,
  label?: string,
  type?: string,
  placeholder?: string,
  onChange: Function,
  value?: string,
  disabled?: any,
  onBlur?: Function,
  onFocus?: Function,
  onKeyPress?: Function,
  onInput?: Function,
  maxLength?: string,
  inputClassName?: string,
  disabledClass?: any,
  allowedInputKeys?: string, // This prop is to block user from typing wrong input - run time
  inputFieldWrapperClass?: string,
  minValue?: string,
  imageSource?: string,
  imageClassName?: string,
  lableClassName?: string
};

type State = {
  value: string
};

class InputField extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      value: this.props.value || ''
    };
    this.allowedInputKeysRegex = convertToRegex(this.props.allowedInputKeys);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps && this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    let propsUpdated = true;
    let stateUpdated = true;
    if (nextProps) {
      if (
        nextProps.name === this.props.name &&
        nextProps.label === this.props.label &&
        nextProps.type === this.props.type &&
        nextProps.placeholder === this.props.placeholder &&
        nextProps.value === this.props.value &&
        nextProps.disabled === this.props.disabled &&
        nextProps.maxLength === this.props.maxLength &&
        nextProps.inputClassName === this.props.inputClassName &&
        nextProps.disabledClass === this.props.disabledClass &&
        nextProps.inputFieldWrapperClass ===
          this.props.inputFieldWrapperClass &&
        nextProps.allowedInputKeys === this.props.allowedInputKeys
      ) {
        propsUpdated = false;
      }
    }
    if (nextState) {
      if (nextState.value === this.state.value) {
        stateUpdated = false;
      }
    }
    return propsUpdated || stateUpdated;
  }

  onChangeHandler(val: string, target: any) {
    if (this.props.allowedInputKeys) {
      const allowedInput = this.props.allowedInputKeys;
      if (allowedInput === 'onlynumber') {
        if (!/^[0-9]*$/.test(val)) {
          // regex test for only number
          return;
        }
      } else if (allowedInput === 'onlytext') {
        if (!/^[a-zA-Z ]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'phoneNumber') {
        if (!/^[0-9]{0,10}$/.test(val)) {
          //regex for 10 digit phone number
          return;
        }
      } else if (allowedInput === 'alphaNumeric') {
        if (!/^[a-zA-Z0-9 ]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'onlyCapitalText') {
        if (!/^[A-Z]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'decimalnumber') {
        if (!/^(\d*\.?\d{0,9}|\.\d{1,9})$/.test(val)) {
          return;
        }
      } else if (allowedInput === 'numericcoma') {
        if (!/^[\d{1,10}(,\d{1,10})]*$/.test(val)) {
          return;
        }
      } else if (allowedInput === 'validCn') {
        if (
          !/^[\d]{0,10}(\-[\d]{0,10}){0,1}([,][\d]{0,10}(\-[\d]{0,10}){0,1})*$/.test(
            val
          )
        ) {
          return;
        }
      }
    }

    this.setState(
      {
        value:
          this.props.type === 'number' && this.props.maxLength
            ? val.slice(0, Number(this.props.maxLength))
            : val
      },
      () => {
        this.props.onChange(val, target);
      }
    );
  }

  onBlurHandler(val: any) {
    if (this.props.onBlur) {
      this.props.onBlur(val);
    }
  }

  onInputHandler(e) {
    if (this.props.onInput) {
      this.props.onInput(e);
    }
  }

  onKeyPressHandler(event: any) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(event);
    }
  }

  onFocusHandler(event: any) {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  }

  onWheelHandler(event: any) {
    if (this.props.onWheel) {
      this.props.onWheel(event);
    }
  }

  render() {
    return (
      <div
        className={`input-field-wrappper ${this.props.inputFieldWrapperClass ||
          ''}`}
      >
        {this.props.label ? (
          <div
            className={` ${styles.inputLabel} input-label ${this.props
              .lableClassName || ''} ${
              this.props.isCalledFromRivigo ? styles.inputLabelWebsite : ''
            }`}
          >
            {this.props.label}
          </div>
        ) : null}
        <div className="l-row">
          <input
            id={this.props.id}
            className={` ${styles.inputField} ${
              this.props.disabled ? styles[this.props.disabledClass] : ''
            } input-field ${this.props.inputClassName} ${
              this.props.isCalledFromRivigo ? styles.inputFieldWebsite : ''
            }`}
            name={this.props.name}
            type={this.props.type}
            placeholder={this.props.placeholder}
            value={this.state.value}
            disabled={this.props.disabled || false}
            onChange={e => this.onChangeHandler(e.target.value, e.target)}
            onBlur={event => this.onBlurHandler(event.target.value)}
            onFocus={event => this.onFocusHandler(event.target.value)}
            onWheelCapture={e => this.onWheelHandler(e)}
            onWheel={e => this.onWheelHandler(e)}
            maxLength={this.props.maxLength}
            min={this.props.minValue}
            onKeyPress={event => this.onKeyPressHandler(event)}
            onInput={e => this.onInputHandler(e)}
          />
          {this.props.imageSource ? (
            <img
              src={this.props.imageSource}
              className={
                this.props.imageClassName ? this.props.imageClassName : ''
              }
              alt="Input Image..."
            />
          ) : null}
        </div>
      </div>
    );
  }
}

// InputField.defaultProps = {
//   label: "passLabelAsProps",
//   type: "text",
//   placeholder: "",
//   value: ""
// };

export default InputField;
